<div class="table">
    @if (titleLeft || titleRight) {
        <div
            class="table__titles"
        >
            <div>{{ titleLeft }}</div>
            <div>{{ titleRight }}</div>
        </div>
    }

    <div class="table__rows">
        <ng-content/>
    </div>
</div>
